import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { FaTrash, FaSuitcase } from 'react-icons/fa';

const GearCardButtons = ({ onTrashClick, onStoreClick }) => (
  <>
    <IconButton
      aria-label="trash"
      icon={<FaTrash />}
      size="xs"
      variant="outline"
      position="absolute"
      top="-10px"
      right="-10px"
      onClick={onTrashClick}
    />
    <IconButton
      aria-label="store"
      icon={<FaSuitcase />}
      size="xs"
      variant="outline"
      position="absolute"
      top="-10px"
      right="15px"
      onClick={onStoreClick}
    />
  </>
);

export default GearCardButtons;
